module.exports = __webpack_public_path__ + "static/all-that-you-leave-behind-612030084669a2557f891caeb0716705.jpg";